import styled, { css } from 'styled-components';

import type { ThemeColorType } from 'src/styles/theme';

export const HorizontalRule = styled.hr<{ backgroundColor?: ThemeColorType; margin?: string; width?: string }>`
  border: 0 none;
  height: 0.1rem;

  ${props =>
    props.width &&
    css`
      width: ${props.width}rem;
    `}
  background-color: ${props =>
    props.backgroundColor ? props.theme.colors[props.backgroundColor] : props.theme.colors.capsuleGray10};
  margin: ${props => props.margin ?? 'inherit'};
`;
